import { h, Host } from "@stencil/core";
import { LoaderVariant } from "./loader.enum";
export class Loader {
    constructor() {
        this.variant = LoaderVariant.Horizontal;
    }
    render() {
        return h(Host, { key: 'd3bf105261dbba8a793ca9970dbe7e66f6250387', variant: this.variant, role: "alert", "aria-busy": "true" });
    }
    static get is() { return "ux-loader"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["loader.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["loader.css"]
        };
    }
    static get properties() {
        return {
            "variant": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "\"horizontal\" | \"spinner\" | LoaderVariant",
                    "resolved": "\"horizontal\" | \"spinner\" | LoaderVariant.Horizontal | LoaderVariant.Spinner",
                    "references": {
                        "LoaderVariant": {
                            "location": "import",
                            "path": "./loader.enum",
                            "id": "src/components/loader/loader.enum.ts::LoaderVariant"
                        }
                    }
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Represents the LoaderVariant property of the component.\n\nThis property is used to determine the visual style of a loader component.\nIt is an enumeration that can take on one of two values:\n\n- `LoaderVariant.Horizontal`: Displays the loader as a horizontal bar.\n- `LoaderVariant.Spinner`: Displays the loader as a spinning circle.\n\nBy default, this property is set to `LoaderVariant.Horizontal`."
                },
                "attribute": "variant",
                "reflect": false,
                "defaultValue": "LoaderVariant.Horizontal"
            }
        };
    }
}
//# sourceMappingURL=loader.js.map
